import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { Navigate } from "react-router-dom";

import {
  loginUser,
  verifyLoginMfa,
  initializeLoginMfa,
} from "../../../redux/features/auth/authSlice";

import LoginForm from "../../../components/auth/login/LoginForm";

import MfaLoginForm from "../../../components/auth/login/MfaLoginForm";

import MfaSetupForm from "../../../components/auth/login/MfaSetupForm";

import "./LoginPage.css";

export default function LoginPage() {
  const dispatch = useDispatch();

  const { status, isLoading, error, mfaToken, mfaSetupData } = useSelector(
    (state) => state.auth,
  );

  /**
   * LOGIN
   */
  const handleLogin = ({ email, password }) => {
    dispatch(
      loginUser({
        email,
        password,
      }),
    );
  };

  /**
   * VERIFY MFA
   */
  const handleVerifyMfa = (code) => {
    if (!mfaToken) return;

    dispatch(
      verifyLoginMfa({
        mfaToken,
        code,
      }),
    );
  };

  /**
   * AUTO INITIALIZE MFA SETUP
   */
  useEffect(() => {
    if (status === "mfa_setup_required" && mfaToken) {
      dispatch(
        initializeLoginMfa({
          mfaToken,
        }),
      );
    }
  }, [dispatch, status, mfaToken]);

  /**
   * AUTHENTICATED
   */
  if (status === "authenticated") {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="login-card">
      <div className="login-card__header">
        <span>POWER Login</span>

        {/* LOGIN */}
        {status === "idle" && (
          <>
            <h2>Aanmelden</h2>

            <p>Meld je aan met je POWER-account.</p>
          </>
        )}

        {/* LOGIN ERROR */}
        {status === "error" && (
          <>
            <h2>Aanmelden</h2>

            <p>Controleer je gegevens en probeer opnieuw.</p>
          </>
        )}

        {/* MFA SETUP */}
        {status === "mfa_setup_required" && (
          <>
            <h2>MFA instellen</h2>

            <p>Configureer eerst MFA om verder te gaan.</p>
          </>
        )}

        {/* MFA VERIFY */}
        {status === "mfa_required" && (
          <>
            <h2>MFA verificatie</h2>

            <p>Vul de code uit je authenticator-app in.</p>
          </>
        )}
      </div>

      {/* MFA SETUP */}
      {status === "mfa_setup_required" ? (
        <MfaSetupForm
          qrCode={mfaSetupData?.qr_code}
          manualCode={mfaSetupData?.manual_code}
          onSubmit={handleVerifyMfa}
          isLoading={isLoading}
          error={error}
        />
      ) : null}

      {/* MFA VERIFY */}
      {status === "mfa_required" ? (
        <MfaLoginForm
          onSubmit={handleVerifyMfa}
          isLoading={isLoading}
          error={error}
        />
      ) : null}

      {/* LOGIN */}
      {(status === "idle" || status === "error") && (
        <LoginForm onSubmit={handleLogin} isLoading={isLoading} error={error} />
      )}
    </div>
  );
}
